export default function Navbar(){
  return (
    <div className={"absolute bg-opacity-20 bg-base-300 md:w-3/4 w-full z-10 fixed top-0"}>
      <a href={"/"}><button className={"btn btn-ghost bg-transparent mr-1 text-white"}>jo-meurer-dach</button></a>
      <a href={"/velux"}><button className={"btn btn-ghost bg-red-600 mr-1 text-white"}>VELUX®</button></a>
      <a href={"/impressum"}><button className={"btn btn-ghost bg-transparent float-right text-white"}>Impressum</button></a>
    </div>
  )
}
